export default __webpack_public_path__ + "static/media/behance_logo_white.a1305f47.svg";